import { useState } from 'react';

import { isBrowser } from 'src/shared/helpers/environment';
import { useIsEmbed } from 'src/shared/hooks/useIsEmbed';
import { useQueryParam } from 'src/shared/hooks/useQueryParam';

/**
 * A helper hook that reads query parameters, sets the onetrust cookies based on them,
 * and closes the onetrust popup
 * This is a hack, used on embedded pages to set the cookies to be what the parent domain
 * has opted them into
 */
export const useSetOnetrustCookiesManually = () => {
  const [onetrustCookies, setOnetrustCookies] = useState<boolean>(false);

  const isEmbed = useIsEmbed();
  const setOneTrust = useQueryParam('setOneTrust') === 'true';
  const necessaryCookieBit = useQueryParam('necessary') === '1' ? 1 : 0;
  const functionalCookieBit = useQueryParam('functional') === '1' ? 1 : 0;
  const personalCookieBit = useQueryParam('personal') === '1' ? 1 : 0;

  if (!onetrustCookies) {
    const now = new Date();

    // Show the consent if they haven't opted into strictly necessary cookies
    if (isBrowser() && setOneTrust && isEmbed && necessaryCookieBit === 1) {
      // otherwise, automatically opt them into the relevant settings
      document.cookie = `OptanonAlertBoxClosed=${now.toString()}; SameSite=None; Secure;`;
      document.cookie = `OptanonConsent=groups=C0001:1,C0003:${functionalCookieBit},SPD_BG:${personalCookieBit},C0002:${personalCookieBit},C0004:${personalCookieBit},C0005:${personalCookieBit}; SameSite=None; Secure;`;
      // fire this event to force hide the OTC box with CSS
      const event = new CustomEvent('OTConsentApplied');
      window.dispatchEvent(event);
      setOnetrustCookies(true);
    }
  }
};
